export const LOAD_PACKAGE_LIST = 'package/LOAD_PACKAGE_LIST';
export const LOAD_PACKAGE_LIST_SUCCESS = 'package/LOAD_PACKAGE_LIST_SUCCESS';
export const LOAD_PACKAGE_LIST_ERROR = 'package/LOAD_PACKAGE_LIST_ERROR';

export const LOAD_PACKAGE_DETAIL = 'package/LOAD_PACKAGE_DETAIL';
export const LOAD_PACKAGE_DETAIL_SUCCESS =
  'package/LOAD_PACKAGE_DETAIL_SUCCESS';
export const LOAD_PACKAGE_DETAIL_ERROR = 'package/LOAD_PACKAGE_DETAIL_ERROR';

export const CREATE_PACKAGE = 'package/CREATE_PACKAGE';
export const CREATE_PACKAGE_SUCCESS = 'package/CREATE_PACKAGE_SUCCESS';
export const CREATE_PACKAGE_ERROR = 'package/CREATE_PACKAGE_ERROR';

export const UPDATE_PACKAGE = 'package/UPDATE_PACKAGE';
export const UPDATE_PACKAGE_SUCCESS = 'package/UPDATE_PACKAGE_SUCCESS';
export const UPDATE_PACKAGE_ERROR = 'package/UPDATE_PACKAGE_ERROR';

export const DELETE_PACKAGE = 'package/DELETE_PACKAGE';
export const DELETE_PACKAGE_SUCCESS = 'package/DELETE_PACKAGE_SUCCESS';
export const DELETE_PACKAGE_ERROR = 'package/DELETE_PACKAGE_ERROR';

export const RESET_PACKAGE = 'package/RESET_PACKAGE';

export const LOAD_ASSESSMENT_LIST = 'package-assessment/LOAD_ASSESSMENT_LIST';
export const LOAD_ASSESSMENT_LIST_SUCCESS =
  'package-assessment/LOAD_ASSESSMENT_LIST_SUCCESS';
export const LOAD_ASSESSMENT_LIST_ERROR =
  'package-assessment/LOAD_ASSESSMENT_LIST_ERROR';

export const RESET_ASSESSMENT_LIST = 'package-assessment/RESET_ASSESSMENT_LIST';

export const RESET_PACKAGE_LIST = 'package-assessment/RESET_PACKAGE_LIST';
export const RESET_PACKAGE_DETAIL = 'package-assessment/RESET_PACKAGE_DETAIL';
